import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {selectIsDeviceDataLoading} from '@/state/selectors/device';

const useDeviceSettingsScrollToTop = (viewportRef) => {
    const isDeviceDataLoading = useSelector(selectIsDeviceDataLoading);

    useEffect(() => {
        if (isDeviceDataLoading || !viewportRef.current) return;

        viewportRef.current.scrollTo({
            top: 0,
        });
    }, [isDeviceDataLoading]);
};

export default useDeviceSettingsScrollToTop;
